import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, NavigationEnd, NavigationError, NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router'
import { AuthorizerService } from '@vcomply/authorizer'
import { shareReplay, take } from 'rxjs/operators'
import { SessionManagementService } from 'src/app/services/session-management.service'
import { UtilityService } from 'src/app/services/utility.service'
import { environment } from 'src/environments/environment'
import { WEBSITE_URL } from 'src/app/shared/constants/website-constant'

@Component({
  selector: 'app-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.less'],
})
export class ContainerComponent implements OnInit {
  signInUpToggle = false
  public year = new Date().getFullYear()
  constructor(public utility: UtilityService, private router: Router, private route: ActivatedRoute, private authorizer: AuthorizerService, private sessionService: SessionManagementService) {
    this.setRedirectURL()
    this.utility.setIpInGlobalState()
    this.setLogo()
  }
  isForceSignin = false
  prepopulatedMail: string | null = ''
  loadingRouteConfig = false
  redirectURL = ''
  /*Default password policy for app,dev,beta subdomains*/
  defaultPolicy = {
    password_policy: {
      MIN_LENGTH: 8,
      MANDATORY_CHARACTER: ['NUMERIC', 'SPECIAL_CHARACTER', 'LOWER_CASE', 'UPPER_CASE'],
    },
  }

  logoURL = '../assets/images/logo.svg'
  webURL: string = WEBSITE_URL

  ngOnInit(): void {
    this.initializeSubDomain()
    this.handleRouteLoading()
    this.setSignInSignUp()
    this.routeChangeHandler()
    this.handleQueryParams()
    this.loginStateBasedDecision()
  }

  setLogo() {
    this.utility.subDomainDetails.subscribe({
      next: (res: any) => {
        if (res?.organisation_logo) {
          this.logoURL = environment?.s3Url + environment?.s3Bucket + '/logo/huge/' + res?.organisation_logo
        } else {
          this.logoURL = '../assets/images/logo.svg'
        }
      },
      error: (err: any) => {
        this.logoURL = '../assets/images/logo.svg'
      },
    })

    //  if (['tls'].includes(this.utility.getSubDomain())){
    //     this.logoURL = '../assets/images/tls-contact-logo.png';
    //   }else{
    //     this.logoURL = '../assets/images/logo.svg';
    //   }
  }
  setDefaultLogo() {
    this.logoURL = '../assets/images/logo.svg'
  }
  initializeSubDomain() {
    this.utility.globalState.subDomain = this.utility.getSubDomain()
    if (!['app', 'dev', 'beta'].includes(this.utility.getSubDomain())) {
      this.utility.setSubDomainDetails()
    }
  }
  /**
   * Decides weather to show the sign in/sign up toggle or not.
   */
  setSignInSignUp() {
    if (['/signin', '/signup', '/change-password', '/forgot-password'].includes(this.router.url.split('?')[0])) {
      this.signInUpToggle = true
    } else {
      this.signInUpToggle = false
    }
  }

  handleRouteLoading() {
    this.router.events.subscribe((event) => {
      if (event instanceof RouteConfigLoadStart) {
        this.loadingRouteConfig = true
      } else if (event instanceof RouteConfigLoadEnd) {
        this.loadingRouteConfig = false
      }
    })
  }
  /**
   * Handles query params on initial page load
   */
  handleQueryParams() {
    const loginType: string | null = this.route.snapshot.queryParamMap.get('force')
    if (loginType === 'login') {
      this.isForceSignin = true
    } else {
      this.isForceSignin = false
    }
    this.prepopulatedMail = this.route.snapshot.queryParamMap.get('email_id')
    this.redirectURL = this.route.snapshot.queryParams['redirectURL']
    // if(this.route.snapshot.queryParamMap.get('integration')){
    //   localStorage.setItem("integration",JSON.stringify({
    //     timestamp:Date.now(),
    //     type: this.route.snapshot.queryParamMap.get('integration')??"",
    //     exchangeId:this.route.snapshot.queryParamMap.get('exchangeId')??"",
    //     email: this.route.snapshot.queryParamMap.get('integration_email')??"",
    //   }))
    // }
  }

  routeChangeHandler() {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationStart) {
      }
      if (event instanceof NavigationEnd) {
        const url = event

        this.handleQueryParams()
        this.loginStateBasedDecision()
        this.setSignInSignUp()
      }
      if (event instanceof NavigationError) {
        // redirect to something went wrong page in future
      }
    })
  }

  /**
   * This function decides weather to go to sigin pages or any other pages.
   */
  loginStateBasedDecision() {
    const byPassRoutes = ['/change-password']
    if (this.utility.isIntegrationMode() && this.utility.isLoggedIn() === true) {
      this.utility.redirectToIntegration()
    } else {
      if (this.utility.isLoggedIn() === true && !byPassRoutes.includes(this.router.url.split('?')[0]) && !window.location.href.includes('?email_id=')) {
        this.utility.setLoadingState(true)
        this.utility.redirectToURL()
      } else if (byPassRoutes.includes(this.router.url.split('?')[0])) {
        this.utility.setLoadingState(true)
      } else {
        this.checkADUser()
      }
    }
  }

  /**
   * Checks for AD user from subdomain details
   */
  checkADUser() {
    const whiteListedSubDomains = ['app', 'dev', 'beta'] // These are the subdomains on which we don't need to fetch subdomain details default password policy is applied
    if (!whiteListedSubDomains.includes(this.utility.getSubDomain())) {
      this.utility.subDomainDetails.subscribe({
        next: (details: any) => {
          this.subDomainHandler(details)
        },
        error: () => {
          this.subDomainHandler(this.defaultPolicy)
        },
      })
    } else {
      this.subDomainHandler(this.defaultPolicy)
    }
  }

  /**
   * Handle roting based on forced login status and subdomain details
   * @param details
   */
  subDomainHandler(details: any) {
    this.utility.globalState.domainDetails = details
    this.utility.setPasswordPolicy(details)
    if ((details?.is_ad_enabled || details?.tenant_id) && !this.isForceSignin) {
      this.router.navigate(['/login'], { queryParams: { redirectURL: this.redirectURL } })
      this.utility.setLoadingState(true)
    } else {
      const whitelistedRoute = ['', '/signin', '/signup', '/change-password', '/forgot-password']
      if (whitelistedRoute.includes(this.router.url.split('?')[0])) {
        this.utility.setLoadingState(true)
      } else if (!this.isForceSignin) {
        this.decideSignInPage(details)
      }
    }
  }

  /**
   * This function decides the signin page for email based and sso based users.
   */
  decideSignInPage(details: any) {
    if ((details?.is_ad_enabled || details?.tenant_id) && !this.isForceSignin) {
      this.router.navigate(['/login'], { queryParams: { redirectURL: this.redirectURL } })
      this.utility.setLoadingState(true)
    } else {
      if (this.isForceSignin) {
        this.router.navigate(['/signin'], { queryParams: { force: 'login', redirectURL: this.redirectURL } })
        this.utility.setLoadingState(true)
      } else if (this.prepopulatedMail) {
        this.router.navigate(['/signin'], { queryParams: { email_id: this.prepopulatedMail, redirectURL: this.redirectURL } })
        this.utility.setLoadingState(true)
      } else {
        this.router.navigate(['/signin'], { queryParams: { redirectURL: this.redirectURL } })
        this.utility.setLoadingState(true)
      }
    }
  }

  private setRedirectURL() {
    const redirectURL = this.getRedirectedURL()
    if (redirectURL) {
      this.sessionService.saveItemOnSession('redirectURL', redirectURL)
    }
  }

  private getRedirectedURL() {
    const queryParams = this.route.snapshot.queryParamMap
    return queryParams.get('redirectURL') ?? undefined
  }
}
